<div class="show-system-log" [ngClass]="{ checked: showSystemLog }">
  <div class="show-system-log__title">
    <h3>{{ title() }}</h3>
  </div>
  <div class="show-system-log__toggle">
    <mat-slide-toggle [checked]="showSystemLog" (change)="toggle()"></mat-slide-toggle>
  </div>
</div>
